export default __webpack_public_path__ + "static/media/PMI.01d66556.jpg";